<div class="d-flex flex-column h-100 text-grey">
  <div class="left-title-box">
    <div class="left-title">Menu</div>
  </div>
  <div class="left-content flex-grow-1">
    <div class="sidenav">
      <a *ngFor="let property of properties; let i = index"
         [ngClass]="{ active: selectedIndex == i }"
         (click)="sendData(i, property)">
        <span class="{{ property.spanClass }}" aria-hidden="true"></span>
        {{ property.name }}
      </a>
    </div>
  </div>
</div>

